import { Injectable } from '@angular/core';
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  private echo: Echo;

  constructor() {
    window.Pusher = Pusher;
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: 'ca957f75398e83123fc2',
      cluster: 'ap2'
    });
  }

  listenToChannel(channel: string, event: string, callback: (data: any) => void): void {
    this.echo.channel(channel).listen(event, (data: any) => {
      callback(data);
    });
  }
}
